import { motion } from "framer-motion";
import { Bot, TrendingUp, ShieldCheck, Camera, Globe, Languages } from "lucide-react";
import { useT } from "@/i18n";

const ITEMS = [
  { icon: Bot, color: "from-violet-400 to-purple-600", es: ["Inteligencia artificial para tu día a día", "Usarás la IA para trabajar, crear y entender lo que tu hijo usa."], en: ["AI for your daily life", "Use AI to work, create and understand what your child uses."] },
  { icon: TrendingUp, color: "from-lime-400 to-green-500", es: ["Emprender en familia", "Ideas de negocio, precios y nombres para empezar juntos un proyecto."], en: ["Family entrepreneurship", "Business ideas, pricing and names to start a project together."] },
  { icon: Globe, color: "from-amber-300 to-orange-400", es: ["Tu propia web", "Plataformas fáciles, dominio y hosting para tu negocio o proyecto."], en: ["Your own website", "Easy platforms, domain and hosting for your business or project."] },
  { icon: Camera, color: "from-sky-300 to-blue-500", es: ["Fotos profesionales", "ISO, apertura, velocidad y luz para mejores fotos de tus productos."], en: ["Pro photos", "ISO, aperture, speed and light for better photos of your products."] },
  { icon: Languages, color: "from-rose-400 to-pink-500", es: ["Inglés junto a tu hijo", "Practiquen palabras y frases en familia mientras crean."], en: ["Spanish with your child", "Practice words and phrases as a family while creating."] },
  { icon: ShieldCheck, color: "from-fuchsia-400 to-violet-600", es: ["Guiar con seguridad", "Cómo acompañar a tu hijo en internet y con la IA de forma segura."], en: ["Guide safely", "How to support your child online and with AI safely."] },
];

const TEXT = {
  es: { a: "¡Tú también", b: "aprenderás!", sub: "Lumi & Spark no es solo para niños: es una app para toda la familia. Usa los mismos mundos y talleres para aprender a tu ritmo." },
  en: { a: "You'll", b: "learn too!", sub: "Lumi & Spark isn't only for kids: it's an app for the whole family. Use the same worlds and workshops to learn at your own pace." },
};

export default function ParentsLearn() {
  const { lang } = useT();
  const tx = TEXT[lang];
  return (
    <section className="sky-bg rounded-[2rem] border-4 border-white shadow-xl p-4 sm:p-8 mt-8" data-testid="parents-also-learn">
      <div className="text-center">
        <h2 className="font-fredoka text-3xl sm:text-5xl font-bold leading-tight">
          <span className="bubble-text text-white">{tx.a} </span>
          <span className="bubble-text text-yellow-300">{tx.b}</span>
        </h2>
        <p className="mt-4 max-w-2xl mx-auto bg-white/90 rounded-3xl px-5 py-3 text-sm sm:text-lg font-bold text-blue-900 shadow-lg">{tx.sub}</p>
      </div>
      <div className="mt-8 grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5">
        {ITEMS.map((it, i) => {
          const Icon = it.icon;
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.07 }}
              className={`glossy-tile relative bg-gradient-to-br ${it.color} rounded-[2rem] p-2 sm:p-3 flex flex-col`}
              data-testid={`parent-learn-${i}`}
            >
              <div className="h-20 sm:h-28 flex items-center justify-center">
                <div className="bg-white/90 rounded-3xl p-3 sm:p-4 shadow-lg"><Icon className="w-8 h-8 sm:w-12 sm:h-12 text-blue-950" strokeWidth={2.2} /></div>
              </div>
              <div className="relative flex-1 bg-white/85 rounded-[1.5rem] px-2 sm:px-4 py-2 sm:py-3 text-center">
                <h3 className="font-fredoka text-sm sm:text-xl font-bold text-blue-950 leading-tight">{it[lang][0]}</h3>
                <p className="mt-1 text-[11px] sm:text-sm text-blue-900/80 font-semibold leading-snug">{it[lang][1]}</p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
